var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "confirm_area", attrs: { id: "content" } }, [
    _c("div", { staticClass: "input_confirm" }, [
      _c("ul", [
        !_vm.isPrivateUser
          ? _c("li", [
              _c("span", [_vm._v("業種：")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.corpTypeLabel))])
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isPrivateUser
          ? _c("li", [
              _c("span", [_vm._v("所属部署：")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.userForm.corpDept))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", [
          _c("span", [_vm._v("氏名：")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              _vm._s(_vm.userForm.userLastName) +
                " " +
                _vm._s(_vm.userForm.userFirstName)
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("span", [_vm._v("氏名（カナ）：")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              _vm._s(_vm.userForm.userLastNameKana) +
                " " +
                _vm._s(_vm.userForm.userFirstNameKana)
            )
          ])
        ]),
        _vm._v(" "),
        !_vm.isEdit
          ? _c("li", [
              _c("span", [_vm._v("メールアドレス：")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.userForm.email))])
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isEdit
          ? _c("li", [
              _c("span", [_vm._v("パスワード：")]),
              _vm._v(" "),
              _c("span", [_vm._v("********")])
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isEdit
          ? _c("li", [
              _c("span", [_vm._v("mm/styleをどこで知りましたか？：")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.infosrcLabel))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", [
          _c("span", [_vm._v("メールマガジンの受信：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.recvInfoLabel))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "send_mail" }, [
        _vm._v(
          "※自動メールにて返信しますので、「@domans.co.jp」からのメールを受信許可に設定してください。"
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b7128ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b7128ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/user/DcUserConfirm.vue
// module id = null
// module chunks = 